import React from 'react';
import PropTypes from 'prop-types';
import {TweenMax, Elastic} from 'gsap/all';

class AnswerButton extends React.Component {   

    constructor(props){
        super(props);
        this.trigger = this.trigger.bind(this);
        this.state =  {
            activated :false,
            incorrect : false,
            correct : false,
        }
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    componentWillReceiveProps(newProps){
        if(this.state.incorrect) return;

        if(this.state.activated && (newProps.incorrect.indexOf(newProps.option)>-1) ){
            this.setState({incorrect : true});
            TweenMax.fromTo(this.node, 1, { rotation: -2}, {rotation: 0,ease:Elastic. easeOut.config( 5, 0.2)});
        }
    }

   
    trigger(){
        this.setState({
            activated : true,
            correct : (this.props.option==this.props.correct)
        }, this.props.onSelect)
    }

    render(){

        const getClass = ()=>{
            let classList = ['AnswerButton'];
            if(this.state.correct && this.state.activated) {
                classList.push('correct'); 
            }
            if(this.state.incorrect){
                classList.push('incorrect'); 
            }
            return classList.join(" ");
        }
        return (
            <div>
            <button className={getClass()}
            ref={(node)=>this.node=node}
                onClick={this.trigger}
                disabled={this.props.playPaused}
            >
                {this.props.option}
                
            </button>
            <style jsx>{`
                    .AnswerButton {
                        display:block!important;
                        padding:15px 20px!important;
                        background: #008C96;
                        width: calc( 100% - 20px);
                        text-align: center!important;
                        margin:0px 0px 10px 0px!important;
                        border-radius: 10px;
                        text-transform: uppercase;
                        color:#fff;
                        box-sizing: border-box;
                        transition: background 0.3s;
                        cursor: pointer;
                        font-size: 20px!important;
                        -webkit-tap-highlight-color:  rgba(255, 255, 255, 0); 
                        outline: #008C96;
                    }
                    
                    
                    .AnswerButton:disabled {
                        background: #ccc;
                    }
                    .AnswerButton.incorrect {
                        transition: background 0.3s;
                        background: red;
                    }
                    .AnswerButton.correct {
                        transition: background 0.1s;
                        background: #529a62;
                    }
                    @media all and (max-width:599px){
                        .AnswerButton {
                            display:block!important;
                            margin-left:0px!important;
                            margin-right:0px!important;
                            font-size:16px!important;
                            width:100%;
                            padding:10px 20px!important;
                           
                        }
                    }
                `}</style>
            </div>
        )
    }
}

AnswerButton.propTypes = {
    
}

export default AnswerButton;